import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=f8878894&scoped=true"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=f8878894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8878894",
  null
  
)

export default component.exports